import React from 'react'
import Constants from 'EurestoFonction/Constants'
import DataComponent from 'EurestoComponents/DataComponents/index'
import User from 'EurestoClass/User'
import Data from 'EurestoClass/Data'

import Grid from '@material-ui/core/Grid'
import Avatar from 'Components/Avatar'

import Recherche from 'EurestoComponents/Recherche'

import Card from '../../Component/Card'
import Search from '../Search'

export default (props) => {

  const columns = [
    {
      Header: '',
      accessor: 'vip',
      show: props.type === 'client',
      width: 30,
      Cell: row => {
        const style = {
          margin: 0, padding: 0, height: '100%',
        }
        return (
          <Grid container spacing={0} style={style} justify={'space-around'}
            alignItems={'center'} direction={'column'}>
            <DataComponent
              name="vip"
              inline={true}
              disabled={true}
              data={row.original.vip}
              contact={row.original}
              type={Constants.typeSaisie.Stars}
              actif={(row.original.archive_id === null || row.original.archive_id === undefined)}
            />
          </Grid>
        )
      },
    },
    { Header: 'id', accessor: 'id', show: false },
    {
      Header: () => <span style={{ cursor: 'not-allowed' }}><i className="EurestoPrimary--text ei-module_crm"
        aria-hidden="true" /></span>,
      id: 'entite',
      sortable: false,
      width: 48,
      Cell: (row) => {
        return (
          <div style={{ position: 'relative' }}>
            <Avatar
              type={row.original.entite === 1 && 'contact' || 'entite'}
              src={row.original.media_lien}
              style={{ width: '45px', height: '45px', padding: 5 }} />
          </div>
        )
      },
    }, {
      Header: () => <span style={{ cursor: 'not-allowed' }}>{EurestoI18n.t('crm:Qualité')}</span>,
      id: 'qualite',
      show: props.type === 'client',
      sortable: false,
      width: 100,
      Cell: (row) => {
        let libelleQualite = ''
        if (row.original.qualite_id !== undefined && row.original.qualite_id !== null) {
          const qualiteFound = Data.get(Constants.module.CRM, Constants.donnee.qualite, { id: row.original.qualite_id })
          libelleQualite = qualiteFound.libelle
        }

        return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
          alignItems={'center'}
          className={row.original.type === Constants.access.ETABLISSEMENT && 'EurestoSecondary--text'}>
          {libelleQualite}
        </Grid>
      },
    },
    {
      Header:
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-start'}
          alignItems={'center'}>
          <b>Personne/Entité</b>
        </Grid>,
      id: 'libelle',
      accessor: row => {
        let libelleCivilite = ''
        if (row.civilite_id !== undefined && row.civilite_id !== null && row.entite === 1) {
          const civiliteFound = Data.get(Constants.module.COMMUN, Constants.donnee.civilite, { id: row.civilite_id })
          libelleCivilite = civiliteFound.abrege
        }
        return (libelleCivilite && (libelleCivilite + ' ') || '') + row.libelle
      },
      minWidth: 130,
      Cell: row => {
        return (
          <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-start'}
            alignItems={'center'}>
            <b
              className={row.original.type === Constants.access.ETABLISSEMENT && row.original.licence_active !== 1 && 'EurestoError--text' || ''}>{row.value}</b>
          </Grid>
        )
      },
    },
    {
      Header: <span>{EurestoI18n.t('commun:Email')}/{EurestoI18n.t('commun:Téléphone')}</span>,
      accessor: 'email',
      sortable: false,
      show: props.type === 'client',
      minWidth: 100,
      Cell: row => {
        return (
          <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'space-around'}
            alignItems={'center'} direction={'column'}>
            <span>{row.original.email}</span>
            <span>{row.original.portable || row.original.fixe || ''}</span>
          </Grid>
        )
      },
    },
    {
      Header: <span>{EurestoI18n.t('commun:Ville')}/{EurestoI18n.t('commun:CP')}</span>,
      accessor: 'ville',
      sortable: false,
      show: props.type === 'client',
      minWidth: 100,
      Cell: row => {
        return (
          <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'space-around'}
            alignItems={'center'} direction={'column'}>
            <span>{row.original.ville}</span>
            <span>{row.original.cp}</span>
          </Grid>
        )
      },
    },
    {
      Header: 'Version',
      accessor: 'version',
      show: User.TypeAccess.get(Constants.access.EURESTO),
      minWidth: 30,
      Cell: row => (
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
          alignItems={'center'}>
          {row.original.version}
        </Grid>
      )
    },

  ]
  return (
    <Recherche
      loading={props.loading}
      showSearch={props.showSearch}
      searchComponent={<Search searchProps={props.searchProps} unsave={props.unsave === undefined ? true : props.unsave} defaultSearch={props.defaultSearch} search={props.search || ('client_' + (props.name || '') + User.Entite.get().id)} />}
      view={props.view}
      data={props.data}
      type={props.type}
      style={props.style}
      onClick={props.onClick}
      card={Card}
      columns={columns}
      search={props.search || ('client_' + (props.name || '') + User.Entite.get().id)}
    />
  )

}



// WEBPACK FOOTER //
// ./app/App/Module/CRM/Component/Table/index.js